	export enum InsuranceProductTypeEnum {
		HearingAidMonaural = 1,
		HearingAidBinaural = 2,
		Test = 3,
		Diagnostics = 4
	}
